
import { Component, Vue, Emit, Prop, Watch } from "vue-property-decorator";
import { isMobile, isTablet } from "mobile-device-detect";
import html2canvas from "html2canvas";
import FiltersIcon from "@/assets/icons/FiltersIcon.vue";
import {
  Header,
  HeaderData,
  Footer,
  FooterData,
  Platmap,
  LotDetails,
  SidebarHomePlan,
  Sidebar,
  LotPosition,
  Alert,
  Amenity,
  LotCount,
  NeighborhoodInfo,
  LotDetail,
  NeighborhoodPlatMap,
  LotCountNeighborhood,
  NeighborhoodSoldDetails,
  CommunityQmiDetails,
  QmiDetails,
  planDetails,
  QmiDays,
  NeighborhoodPlanQmiCounts,
  NeighborhoodHomePlans,
  LotInfo,
NeighboorhoodCoords,
QmiJobStatus,
CommunityFutureHomePlans,
ComparedSvgFooterData,
} from "./../../types";
import {
HomeTypeCode,
  ModalType,
  Settings,
  Status,
  UrlFilterList
} from "./../../constant";
import PlatmapHeader from "../AppHeader.vue";
import PlatToolbar from "../AppToolBar.vue";
import PlatFooter from "../AppFooter.vue";
import PlatMapMain from "../PlatMapMain.vue";
import PlatSidebar from "../SideBar.vue";
import AppHeaderCircle from "../AppHeaderCircle.vue"
import MobileFilterModal from "../modal/MobileFilterModal.vue";
import LongArrowLeftIcon from "@/assets/icons/LongArrowLeftIcon.vue";
import {
  apiFetchHeaderDetails,
  apiFetchFooterDetails,
  apiFetchHomePlans,
  apiFetchQmiHomePlans,
apiFetchLotsJobStatus,
} from "./../../api";

@Component({
  components: {
    PlatmapHeader,
    PlatToolbar,
    PlatFooter,
    PlatMapMain,
    PlatSidebar,
    AppHeaderCircle,
    FiltersIcon,
    MobileFilterModal,
    LongArrowLeftIcon,
  },
})
export default class PlatMapPage extends Vue {
  $refs!: any;
  $modal!: any;
  private selectedHomePlanId = "";
  private selectedLotStatus = "";
  private filteredHomePlans=[] as any[];
  private header: Header = { open: false, data: {} as HeaderData };
  private footer: Footer = { open: true, data: [] as FooterData[] };
  private sidebar: Sidebar = { open: true, data: [] as SidebarHomePlan[] };
  private qmiDetails={} as CommunityQmiDetails;
  private selectedJobNum = "";
  private listPlanId = [] as string[];
  private zoomOutDisabled = false;
  private zoomInDisabled = false;
  private centerLatitude = 0;
  private centerLongitude = 0;
  private toolbar = true;
  private soldPercentage = [] as NeighborhoodSoldDetails[];
  private neighborhoodsPlanQmiCount = [] as NeighborhoodPlanQmiCounts[];
  private availableSites = 0;
  private showMobileFilters=false;
  private listHomeTypeMobileFilter = [] as string[];
  private listPlanNameMobileFilter = [] as string[];
  private qmiFilterListMobileFilter=[] as QmiDays[];
  private isMobile = isMobile;
  private isMobilePriceApplied = false;
  private noPricePlanVisited = false;
  private lotsCount: LotCount = {
    available: 0,
    model: 0,
    quickmovein: 0,
    sold: 0,
    reserved: 0
  }
  private planPriceExsist = true;
  private availableLots = 0;
  private neighborhoodLotsCount= [] as LotCountNeighborhood[]
  private listPlanNameId = [] as string[];
  private homeTypeList = new Set<string>();
  private communityHomePlans= [] as SidebarHomePlan[];
  private neighborhoodHomePlans = [] as NeighborhoodHomePlans[];
  private hasMobile = !!(isMobile && !isTablet);
  private onChangeNeighbourhoodCount = 0;
  private totalMobileFilterApplied= 0;
  private minPriceRangeMobileFilter = 0;
  private maxPriceRangeMobileFilter = 0;
  private showMinPriceRangeMobileFilter = 0;
  private showMaxPriceRangeMobileFilter = 0;
  private showPriceRangeMobileFilter = false;
  private changedMinValue = Settings.MinValue;
  private changedMaxValue = Settings.MaxValue;
  private initialHomePlanCount = 0;
  private filterHomeTypeList = [] as string[];
  private filterPlanNameList = [] as string[];
  private filterMaxPrice = Settings.MaxValue;
  private filterMinPrice = Settings.MinValue;
  private sortBy = '';
  private qmiFilterList = [] as QmiDays[];
  private enableMobileApply = false;
  private notReservedPlan = new Set<string>();
  private hoverNeighborZoomLevel = 0;
  private isDisableHoverNeighbor = false;
  private centerMap = {} as NeighboorhoodCoords;
  private planAttachedFutureLot = new Set<string>();
  private matchedSvgfooterData = [] as ComparedSvgFooterData[];
  @Prop() private selectedNeighborhoodCenterLongitude!: string;
  @Prop() private selectedNeighborhoodCenterLatitude!: string;
  @Prop() private platmap!: Platmap;
  @Prop() private lotDetails!: LotDetails;
  @Prop() private neighborhoodId!: string;
  @Prop() private communityId!: string;
  @Prop() private selectedLotId!: string;
  @Prop() private selectedHomePlanIds!: string[];
  @Prop() private loading!: boolean;
  @Prop() private siblingSelected!: boolean;
  @Prop() private amenities!: Amenity[]
  @Prop() private isKioskMode!: boolean;
  @Prop() private neighborhoods!: NeighborhoodInfo[];
  @Prop() private selectedNeighborhoodIds!: string[];
  @Prop() private communityName!: string;
  @Prop() private futureHomePlans!: CommunityFutureHomePlans;

  CleanHomeId() {
    this.selectedHomePlanId = "";
    this.selectedJobNum="";
  }

  @Emit('setZoomLevelMapPage')setZoomLevelMapPage(zoomLevel: number){}
  @Emit('setHomeTypeCount') setHomeTypeCount(homeTypeCount: number){}
  @Emit("showPlanFutureLotFlyout")showPlanFutureLotFlyout(lotInfo: LotInfo, lotId: string){}
  @Emit("setLotId") loadLotInfo(
    lotId: string,
    homeplanIds: string[],
    lotPosition: LotPosition,
    status: string
  ) {
    this.selectedHomePlanId = "";
    this.selectedJobNum="";
    this.selectedLotStatus = status;
    if (isMobile && this.platmap.underlay_on) {
      this.sidebar.open = false;
    }
  }
  @Emit("updateLotInfo") updateLotInfo(lotDetail: LotInfo|LotDetail, lotId: string){}
  @Emit("setAllAmenities") setAllAmenities(allAmenities: Array<Amenity>) {}
  @Emit("loadNeighborhood") loadNeighborhood(
    areaName: string,
    communityName: string,
    neighborhoodName: string
  ) { }
  @Emit("selectNeighborhood") selectNeighborhood (neighborhoodId: string) { }
  @Emit("setNeighborhoodName") setNeighborhoodName(neighborhoodId: string) { }
  @Emit("setLegends") setLegends(legends: string) { }
  @Emit("setAmenities") setAmenities(amenities: Array<string>) { }
  @Emit("setUnderlay") setUnderlay(underlay: boolean) { }
  @Emit("printPDF") printPDF(platmap: string) { }
  @Emit("calculateContactInfoTopPosition") calculateContactInfoTopPosition() { }
  @Emit("handlePrintSelectionClick") handlePrintSelectionClick(
    printOptionSelected: boolean
  ) { }
  @Emit("showLoader") showLoader() { }
  @Emit("hideLoader") hideLoader() { }
  @Emit("handleCloseLotInfo") closeLotInfo() { }
  @Emit("closeAmenityInfo") closeAmenityInfo() { }
  @Emit("notFound") notFound() { }
  @Emit("openModal") openModal(modalName: string) { }
  @Emit("updateChatBotPosition") updateChatBotPosition(isOpenFooter: boolean) { }
  @Emit("setNeighborhoodAreaName") setNeighborhoodAreaName(
    neighborhoodAreaName: string
  ) { }
  @Emit("setCommunityName") setCommunityName(
    communityName: string
  ) { }
  @Emit("setAminityId") loadAminityInfo(
    amenityId: string,
    lotPosition: LotPosition
  ) {
    this.closeLotInfo();
    if (isMobile) this.sidebar.open = false;
  }
  @Emit("fetchPlatmap") fetchPlatmap(
    neighborhoodId: string,
    communityCode: string,
    header: HeaderData
  ) { }
  @Emit("fetchPlatmapCoordinates") fetchPlatmapCoordinates(
    neighborhoodId: string,
    header: HeaderData
  ) { }
  @Emit("setPrintModal") setPrintModal(value) { }
  @Emit("clearSelectedNeighborhoods") clearSelectedNeighborhoods() {
    if(this.hasMobile){
      this.clearMobileFilters();
    }
  }
  @Emit("setselectQmiData")setselectQmiData(selectQmiData: QmiDetails){}
  updateNotOnlyReservedPlan(notReservedPlan: Set<string>){
    this.notReservedPlan = notReservedPlan;
    this.sidebar.data = this.sidebar.data.filter((plan) => this.notReservedPlan.has(plan.plan_id));
  }
  @Watch("listPlanNameId")
  onListPlanNameChange(){
    if(this.listPlanNameId.length&&!this.listPlanNameId.includes(this.selectedHomePlanId)){
      this.selectedHomePlanId="";
    }
  }
  @Watch("sidebar.open") onSidebarOpen() {
    if (this.sidebar.open && isMobile) {
      if(!this.hasMobile){
        this.$refs.platMapMain.closeMapInfoWindow();
      }
      this.closeLotInfo();
      this.closeAmenityInfo();
    }
  }

  sethoverNeighborZoomLevel(zoomLevel: number, isDisableHoverNeighbor: boolean, centerMap: NeighboorhoodCoords){
    this.hoverNeighborZoomLevel = zoomLevel;
    this.isDisableHoverNeighbor = isDisableHoverNeighbor;
    this.centerMap = centerMap;
  }
  hideSibling() {
    if (this.header?.data?.sibling?.length) {
      this.header.data.sibling.forEach((item) => {
        const element = document.getElementById(item.id)
        if (element && !this.selectedNeighborhoodIds.length) {
          this.highlightNeighborhood(item.id, 'none');
        } else if (element && !this.selectedNeighborhoodIds.includes(item.id)) {
          this.highlightNeighborhood(item.id, 'none');
        } else if (element && this.selectedNeighborhoodIds.includes(item.id)) {
          this.highlightNeighborhood(item.id, 'flex');
        }
      })
    }
  }
  highlightNeighborhood(neighborhoodId: string, display: string) {
    const currentNeighborhoodLines = document.getElementById(`LINE-${neighborhoodId}`)?.children;
    if(currentNeighborhoodLines){
      Array.from(currentNeighborhoodLines).forEach((line) => {
        Array.from(line.children).forEach((element) => {
          element["style"].display = display;
        })
      });
    }
  }

  updateFooterData(matchedSvgfooterData: ComparedSvgFooterData[]){
    this.matchedSvgfooterData = matchedSvgfooterData;
  }
  communityLotCount(){
    if (this.neighborhoods.length > 1) {
        this.availableSites = 0;
        this.availableLots = 0;
        this.neighborhoodLotsCount.forEach((neighborhood) => {
          this.availableLots += neighborhood.available;
          this.availableSites += neighborhood.available + neighborhood.quickmovein + neighborhood.future;
        });
      } else {
        this.availableLots = this.neighborhoodLotsCount[0].available;
        this.availableSites = this.neighborhoodLotsCount[0].available + this.neighborhoodLotsCount[0].quickmovein + this.neighborhoodLotsCount[0].future;
      }
  }
  @Watch("selectedNeighborhoodIds") updateLotsCount(newVal: string[] , oldVal: string[]) {
    this.countMobileFiltersApplied();
    this.routeUpdate(newVal, oldVal);
    this.assignHomePlans();
  }

  @Watch('filterPlanNameList')
  @Watch('filterMaxPrice')
  @Watch('filterMinPrice')
  @Watch('filterHomeTypeList')
  @Watch('sortBy')
  @Watch('qmiFilterList') updateRoute(newVal: string[], oldVal: string[]) {
    this.routeUpdate(newVal, oldVal);
  }

  created() {
    this.fetchHeader();
    if(this.isMobile){
      this.footer.open = false;
    }
  }

  mounted() {
    if (this.hasMobile) {
      this.setHeaderHeight();
    }
  }

  updateNewHomePlanCount(planId: string){
    const planAttachedLotsStatus = this.$refs.platMapMain?.getplanAttachedLotsStatus(planId);
    if(planAttachedLotsStatus.size === 1 && planAttachedLotsStatus.values().next().value === Status.FUTURE_HOME){
      this.planAttachedFutureLot.add(planId)
    } 
  }

  setHeaderHeight() {
    const mobileHeader = document.querySelector('.cp-filter') as HTMLDivElement;
    let mobileHeaderHeight = mobileHeader.offsetHeight;
    (document.querySelector('#mainWrap') as HTMLDivElement).style.setProperty('--cpFilterHeight', `${mobileHeaderHeight}px`);
  }

  setFilterProperties(
    listHomeType: string[],
    listPlanName: string[],
    maxPrice: number,
    minPrice: number
  ) {
    this.filterHomeTypeList = listHomeType;
    this.filterPlanNameList = listPlanName;
    this.filterMaxPrice = maxPrice;
    this.filterMinPrice = minPrice;
  }

  setSortProperties(sortBy: string) {
    this.sortBy = sortBy;
  }
  
  setQmiFilterProperties(qmiDays: QmiDays[]) {
    this.qmiFilterList =qmiDays;
  }

  backPageAccess(){
    if(window.history.length)
      window.close();
  }

  setplanPriceExsist(planPriceExsist: boolean) {
    this.planPriceExsist = planPriceExsist;
  }
  updateMobilefilterCount() {
    if(this.isMobilePriceApplied && !this.conditionShowPriceRange && !this.planPriceExsist){
      this.totalMobileFilterApplied += 1;
    }
  }
  // clearMobileFilterNoHomePlan() {
  //   if(this.selectedNeighborhoodIds.length) {
  //     const currentNeighborhood = this.neighborhoodHomePlans.filter((element)=> element.neighborhoodId === this.selectedNeighborhoodIds[0]);
  //     if(currentNeighborhood.length && !currentNeighborhood[0].homePlans.length) {
  //       this.clearMobileFilters();
  //     }
  //   }
  // }

  toggleHeader(): void {
    const { header } = this;
    this.header.open = !header.open;
  }

  routeUpdate(newValue, oldValue) {
    if (newValue !== oldValue) {
      this.$router.push({query: this.createRoutePath()}).catch(()=>{});
    }
  }

  createRoutePath() {
    const newQuery= {...this.$route.query};
    if (this.selectedNeighborhoodIds.length) {
      const currentNeighborhoodData= this.neighborhoods.find((neighborhood) => neighborhood.neighborhood_code === this.selectedNeighborhoodIds[0]);
      newQuery[UrlFilterList.NEIGHBORHOOD] = `${currentNeighborhoodData?.neighborhood_name.toLowerCase()}`;
    } else {
      newQuery[UrlFilterList.NEIGHBORHOOD] = [];
    }
    newQuery[UrlFilterList.PLAN_NAME]= this.filterPlanNameList ?? [];
    newQuery[UrlFilterList.HOME_TYPE] = this.filterHomeTypeList ?? [];
    if (this.sortBy.length) {
      newQuery[UrlFilterList.SORT_BY] = this.sortBy.toString() ?? [];
    }
    newQuery[UrlFilterList.QMI_FILTER] = this.qmiFilterList.map((qmi) => qmi.value) ?? [];
    if (this.filterMaxPrice && this.filterMaxPrice !== Settings.MaxValue) {
      newQuery[UrlFilterList.MAX_PRICE] = this.filterMaxPrice.toString() ?? [];
    } else{
      newQuery[UrlFilterList.MAX_PRICE] = [];
    }
    if (this.filterMinPrice && this.filterMinPrice !== Settings.MinValue) {
      newQuery[UrlFilterList.MIN_PRICE] = this.filterMinPrice.toString() ?? [];
    } else {
      newQuery[UrlFilterList.MIN_PRICE] = [];
    }
    return newQuery;
  }

  toggleToolbar(){
    const { toolbar } = this;
    this.toolbar = !toolbar;
  }

  toggleFooter() {
    const { footer } = this;
    this.footer.open = !footer.open;
    if(this.hasMobile){
      this.sidebar.open = !this.footer.open;
    }
    this.updateChatBotPosition(this.footer.open);
  }
  toggleSidebar() {
    const { sidebar } = this;
    this.sidebar.open = !sidebar.open;
  }
  setHomePlanId(planId: string,jobNum:string) {
    this.filteredHomePlans.forEach((element)=>{
      if((element.plan_id === planId && jobNum === "") || (element.job_number === jobNum))
      {
        this.selectedHomePlanId = planId;
        this.selectedJobNum=jobNum;
      }
    })
    this.closeLotInfo();
    this.closeAmenityInfo();
  }
  hideSidebar() {
    this.sidebar.open = false;
  }
  hideHeader() {
    this.toolbar = false;
    this.header.open = false;
  }
  hideFooter() {
    this.footer.open = false;
  }
  showFooter() {
    this.footer.open = true;
  }
  showSidebar() {
    this.sidebar.open = true;
  }
  showHeader() {
    this.toolbar = true;
    this.header.open = true;
    let timer = setTimeout(() => {
      if(this.$refs.platMapToolbar)
        this.$refs.platMapToolbar.calculateToolbarTopPosition();
      clearTimeout(timer);
    }, 10);
  }
  zoomIn() {
    const { svgZoomIn } = this.$refs.platMapMain;
    svgZoomIn();
    this.closeLotInfo();
    this.closeAmenityInfo();
  }
  zoomOut() {
    const { svgZoomOut } = this.$refs.platMapMain;
    svgZoomOut();
    this.closeLotInfo();
    this.closeAmenityInfo();
  }
  autoFit() {
    const { svgAutoFit } = this.$refs.platMapMain;
    svgAutoFit();
    this.closeLotInfo();
    this.closeAmenityInfo();
  }
  setMapCenter(x: number, y: number) {
    const { setMapCenterUsingPixel } = this.$refs.platMapMain;
    setMapCenterUsingPixel(x, y);
  }
  handlePrintClick() {
    const sessionStorage = window.sessionStorage.getItem(Settings.SESSION_KEY);
    this.closeLotInfo();
    this.closeAmenityInfo();
    this.handlePrintSelectionClick(true);
    if (sessionStorage) {
      this.openModal(ModalType.CROPPING_TOOL);
      this.setPrintModal(true);
    } else {
      this.openModal(ModalType.CONTACT_INFO);
    }
  }
  handleVisitClick() {
    this.closeLotInfo();
    this.handlePrintSelectionClick(false);
    this.openModal(ModalType.CONTACT_INFO);
  }

  setInitialPlansCountData () {
    this.neighborhoods.forEach((neighborhood) => {
      this.neighborhoodsPlanQmiCount.push({
        neighborhoodId: neighborhood.neighborhood_code,
        neighborhoodQmisCount: 0,
        neighborhoodPlansCount: 0,
      });
    });
  }

  changeHomeType(){
    this.header.data.sibling.forEach(neighbor => {
      if(Object.keys(HomeTypeCode).includes(neighbor.home_type)){
        neighbor.home_type = HomeTypeCode[neighbor.home_type]
      }
    })
  }
  async fetchHeader() {
    try {
      this.showLoader();
      this.setInitialPlansCountData();
      const neighborhoodId = this.selectedNeighborhoodIds[0] ?? this.neighborhoods[0].neighborhood_code;
      const data = await apiFetchHeaderDetails(neighborhoodId);
      const { result } = data;
      this.header.data = result as HeaderData;
      this.setCommunityName(this.header.data.community_name);
      this.changeHomeType();
      this.setNeighborhoodAreaName(this.header.data.area_link_name);
      await this.fetchHomePlans();
      await this.fetchFooter();
      this.fetchPlatmap(neighborhoodId, this.communityId, this.header.data);
    } catch (error) {
      this.hideLoader();
      this.notFound();
    }
  }

  reorderLegendPositions (legends: FooterData[]) {
    //legends[2] = sold & legends[3] = reserved
    if (legends && legends.length > 3 ) {
      const swap = legends[2];
      legends[2] = legends[3];
      legends[3] = swap;
    }
    return legends;
  }
  updateLegends(legendArr: Array<string>){
    if((!this.selectedNeighborhoodIds.length && Object.keys(this.futureHomePlans).length) ||
      (Object.keys(this.futureHomePlans).includes(this.selectedNeighborhoodIds[0]))){
      legendArr.push(Status.FUTURE_HOME)
    }
  }

  
  async fetchFooter() {
    try {
      const data = await apiFetchFooterDetails(this.communityId);
      let { result } = data;
      result = this.reorderLegendPositions(result);
      this.footer.data = result as FooterData[];
      if (result.length) {
        let legendArr: Array<string> = [];
        result.map((legend: FooterData) => legendArr.push(legend.status));
        this.updateLegends(legendArr);
        this.setLegends(legendArr.toString());
      }
    } catch (error) {
      this.setLegends("");
      this.footer.data = [] as FooterData[];
    }
  }
  assignHomePlansNeighborhood(data: SidebarHomePlan[]) {
    this.neighborhoodHomePlans = [] as NeighborhoodHomePlans[];
    const neighborhoodsWithHP = [] as string[];
    data.forEach((homePlan) => {
      if(neighborhoodsWithHP.includes(homePlan.neighborhood_code)){
        const requiredNeighborhood = this.neighborhoodHomePlans.find(neighborhood => neighborhood.neighborhoodId === homePlan.neighborhood_code);
        requiredNeighborhood?.homePlans.push(homePlan);
      } else {
        neighborhoodsWithHP.push(homePlan.neighborhood_code);
        this.neighborhoodHomePlans.push({
          neighborhoodId: homePlan.neighborhood_code,
          homePlans: [homePlan]
        });
      }
    });
  }
  assignHomePlansCommunity(data: SidebarHomePlan[]) {
    this.communityHomePlans= [] as SidebarHomePlan[];
    for (const homePlan of data) {
      const reqHomePlan = this.communityHomePlans.find((existHomePlan) => existHomePlan.plan_id === homePlan.plan_id)
      if (reqHomePlan && homePlan.price_low_with_premium !==0 &&
        (reqHomePlan.price_low_with_premium > homePlan.price_low_with_premium ||  reqHomePlan.price_low_with_premium === 0 )) {
        this.communityHomePlans.splice(this.communityHomePlans.indexOf(reqHomePlan), 1);
        this.communityHomePlans.push(homePlan);
      } else if (!reqHomePlan) {
        this.communityHomePlans.push(homePlan);
      }
    }
  }

  assignHomePlans() {
    this.initialHomePlanCount= 0;
    if (this.selectedNeighborhoodIds.length) {
      const selectedNeighborhoodHomePlan = this.neighborhoodHomePlans.find(neighborhood => neighborhood.neighborhoodId === this.selectedNeighborhoodIds[0]);
      this.sidebar.data = selectedNeighborhoodHomePlan ? selectedNeighborhoodHomePlan.homePlans : [] as SidebarHomePlan[];
    } else {
      this.sidebar.data = this.communityHomePlans;
    }
    this.initialHomePlanCount +=this.sidebar.data.length ;
    if(this.selectedNeighborhoodIds.length){
        const count= this.qmiDetails[this.selectedNeighborhoodIds[0]]?.length;
        if(count){
          this.initialHomePlanCount += count;
        }
    }else{
      for(const key of Object.keys(this.qmiDetails)){
        this.initialHomePlanCount += this.qmiDetails[key].length;
      }
    }
  }

  async fetchHomePlans() {
    try {
      const promises = this.neighborhoods.map(neighborhood => apiFetchHomePlans(neighborhood.neighborhood_code, this.communityId));
      const responses = await Promise.all(promises.map(promise => promise.catch((error) => error)));
      const data  = [] as SidebarHomePlan[];
      responses.forEach((eachPromiseData, idx) => {
        if (eachPromiseData.result) {
          data.push(...eachPromiseData.result.home_planes as SidebarHomePlan[]);
          this.setNeighborhoodPlansCount(eachPromiseData.result.home_planes, idx);
        } else {
          this.setNeighborhoodPlansCount([], idx);
        }
      });
      this.assignHomePlansNeighborhood(data);
      this.assignHomePlansCommunity(data);
      this.qmiDetails = await apiFetchQmiHomePlans(this.communityId) as CommunityQmiDetails;
      this.assignHomePlans();
      for(const key of Object.keys(this.qmiDetails))
      {
        for(const value of this.qmiDetails[key])
        {
          value.price=parseInt(value.price);
        }
      }
      this.setNeighborhoodQmisCount();
    } catch (error) {
      this.sidebar.data = [] as SidebarHomePlan[];
    }
  }

  setNeighborhoodPlansCount(neighborhoodPlansData: SidebarHomePlan[], idx: number) {
    const currentNeighborhoodId = this.neighborhoods[idx].neighborhood_code;
    const neighborhoodCountData = this.neighborhoodsPlanQmiCount.find((countData) => countData.neighborhoodId === currentNeighborhoodId);
    if (neighborhoodCountData) {
      neighborhoodCountData.neighborhoodPlansCount = neighborhoodPlansData.length;
    }
  }

  setNeighborhoodQmisCount() {
    for (const [key, value] of Object.entries(this.qmiDetails)) {
      const neighborhoodCountData = this.neighborhoodsPlanQmiCount.find((countData) => countData.neighborhoodId === key);
      if(neighborhoodCountData) {
        neighborhoodCountData.neighborhoodQmisCount = value.length;
      }
    }
  }

  disableZoomIn() {
    this.zoomInDisabled = !this.zoomInDisabled;
  }
  disableZoomOut() {
    this.zoomOutDisabled = !this.zoomOutDisabled;
  }
  recalculateSidebarHeight(height?: number) {
    this.$refs.platMapSidebar &&
      this.$refs.platMapSidebar.calculateDynamicHeight(height);
  }
  calculateSoldLotsPercentage(lotsCountNeighborhood: LotCountNeighborhood[]) {
    this.neighborhoodLotsCount = lotsCountNeighborhood;
    this.communityLotCount();
    lotsCountNeighborhood.forEach((lotCount) => {
      const availableSites = lotCount.available + lotCount.quickmovein + lotCount.future;
      const totalLotsCount = availableSites + lotCount.sold;
      this.soldPercentage.push ({
        neighborhoodId: lotCount.neighborhoodId,
        totalLotsCount: totalLotsCount + lotCount.reserved,
        soldPercentage:  Math.round((lotCount.sold / totalLotsCount) * 100),
      });
      if(lotCount.neighborhoodId === this.selectedNeighborhoodIds[0]) {
        this.availableLots = lotCount.available;
        this.availableSites = lotCount.available + lotCount.quickmovein + lotCount.future;
      }
    });
  }
  setPlanNameListId(listPlanId: string[]) {
    this.listPlanId=listPlanId.slice(0);
  }
  updatefilteredHomePlans(filteredHomePlans: any[]) {
    this.filteredHomePlans=filteredHomePlans;
    this.onChangeNeighbourhoodCount = this.$refs.platMapMain?.countLotsFilterPlans(this.filteredHomePlans) ?? 0;
    // let isHomePlanAvailbleLeftRail=false;
    // filteredHomePlans.forEach((element)=>{
    //   if((element.plan_id === this.selectedHomePlanId && this.selectedJobNum === "") || (element.job_number === this.selectedJobNum))
    //   {
    //     isHomePlanAvailbleLeftRail=true;
    //     return false;
    //   }
    // })
    // if(!isHomePlanAvailbleLeftRail)
    // {
    //   this.selectedHomePlanId="";
    //   this.selectedJobNum="";
    // }
  }
  get conditionShowPriceRange(){
    if(!this.initialHomePlanCount) {
      return true;
    }
    if (this.selectedNeighborhoodIds.length) {
      const currentSoldPercentage = this.soldPercentage.filter((element) => this.selectedNeighborhoodIds.includes(element.neighborhoodId));
      return (currentSoldPercentage.length && currentSoldPercentage[0].soldPercentage) ? currentSoldPercentage[0].soldPercentage >= 100 : true;
    } else {
      const currentSoldPercentage = this.soldPercentage.filter((element) => element.soldPercentage<100);
      return !currentSoldPercentage.length;
    }
  }
  toggleMobileFilterModalVisibility(showMobileFilters = true){
    this.showMobileFilters = showMobileFilters;
    if(!this.conditionShowPriceRange){
      this.showPriceRangeMobileFilter = showMobileFilters;
    }else{
      this.showPriceRangeMobileFilter = false;
    }
  }
  setPlanDetailsHometypeList(communityHomePlans: SidebarHomePlan[],homeTypeList: Set<string>,minPrice: number,maxPrice: number){
    this.communityHomePlans = communityHomePlans;
    this.homeTypeList = homeTypeList;
    this.minPriceRangeMobileFilter= this.showMinPriceRangeMobileFilter= minPrice;
    this.maxPriceRangeMobileFilter= this.showMaxPriceRangeMobileFilter= maxPrice;
  }

  updatePriceRangeMobile(minValue: number,maxValue: number){
    this.changedMinValue = minValue;
    this.changedMaxValue = maxValue;
    this.enableMobileApply = (minValue > this.minPriceRangeMobileFilter) || (maxValue < this.maxPriceRangeMobileFilter);
  }

  applyMobilePriceFilter(minValue: number,maxValue: number){
      this.updatePriceRangeMobile(minValue, maxValue);
      this.minMaxValuePriceRangeMobileFilter();
      this.showPriceRangeMobileFilter = true;
      this.totalMobileFilterApplied+=1;
      this.isMobilePriceApplied = true;
  }
  minMaxValuePriceRangeMobileFilter(){
    let priceMinValueMobileFilter = Settings.MinValue;
    this.showMinPriceRangeMobileFilter =  this.minPriceRangeMobileFilter;
    let priceMaxValueMobileFilter = Settings.MaxValue;
    this.showMaxPriceRangeMobileFilter = this.maxPriceRangeMobileFilter ;
    if(this.changedMinValue > this.minPriceRangeMobileFilter || this.changedMaxValue < this.maxPriceRangeMobileFilter){
      priceMinValueMobileFilter = this.showMinPriceRangeMobileFilter =  this.changedMinValue;
      priceMaxValueMobileFilter = this.showMaxPriceRangeMobileFilter =  this.changedMaxValue;
      this.isMobilePriceApplied = true;
    }else {
      this.isMobilePriceApplied = false;
    }
    return {min: priceMinValueMobileFilter, max: priceMaxValueMobileFilter}
  }
  applyMobileFilters(listPlanName:string[],listHomeType:string[],qmiFilterList:QmiDays[]){
    this.listHomeTypeMobileFilter = listHomeType;
    this.listPlanNameMobileFilter = listPlanName;
    this.qmiFilterListMobileFilter = qmiFilterList;
    const minMax = this.minMaxValuePriceRangeMobileFilter();
    this.countMobileFiltersApplied();
    this.$refs.platMapSidebar && this.$refs.platMapSidebar.filterPlanNameHomeType(listHomeType,listPlanName,minMax.max,minMax.min);
    this.$refs.platMapSidebar && this.$refs.platMapSidebar.setQmiDaysMobileFilter(qmiFilterList);
  }
  clearMobileFilters(){
    this.showMaxPriceRangeMobileFilter = this.changedMaxValue = this.maxPriceRangeMobileFilter;
    this.showMinPriceRangeMobileFilter = this.changedMinValue = this.minPriceRangeMobileFilter;
    this.listHomeTypeMobileFilter = []
    this.listPlanNameMobileFilter = []
    this.qmiFilterListMobileFilter = [];
    this.isMobilePriceApplied = false;
    this.totalMobileFilterApplied = 0;
    this.isMobilePriceApplied = false;
    this.$refs.platMapSidebar.filterPlanNameHomeType([],[],0,0);
    this.$refs.platMapSidebar.setQmiDaysMobileFilter([]);
  }
  countMobileFiltersApplied(){
    this.totalMobileFilterApplied = 0;
    if(this.listHomeTypeMobileFilter.length){
      this.totalMobileFilterApplied += 1;
    }
    if(this.listPlanNameMobileFilter.length){
      this.totalMobileFilterApplied += 1;
    }
    if(this.qmiFilterListMobileFilter.length){
      this.totalMobileFilterApplied += 1;
    }
    this.updateMobilefilterCount();
  }
}
